import Swal from "sweetalert2";

export const valFormValues = (props) => {

    const { formValues } = props;

    const {
        partApellidoPaterno,
        partNombres,
        partCorreo,
        partGenero,
        partNacionalidad,
        partTelefono,

        profInstitucion,
        profDireccion,
        profPais,
        profEstado,
        profGrado,
        profOcupacion,

        simacMiembro,
        simacDesde,
        simacTipoMembresia,
        simacFormarParte,
        simacRecibirInformacion,

        tipoRegistro,
        totalTrabajos,
        trabajos,

        concursoParticipa,
        concursoCategoria,
        concursoAsesorApellidoPaterno,
        concursoAsesorNombres,
        concursoAsesorCorreo,
        concursoAsesorInstitucion,
        concursoAsesorTelefono,
        concursoAsesorMiembro,

    } = formValues;

    // Campos obligatorios
    if ([ 
            partApellidoPaterno, 
            partNombres, 
            partCorreo, 
            partGenero.trim(), 
            partNacionalidad, 
            partTelefono, 
            profInstitucion,
            profDireccion,
            profPais,
            profEstado,
            profGrado,
            profOcupacion,
            simacMiembro,
            simacRecibirInformacion,
            tipoRegistro, 
            concursoParticipa,
        ].includes("")) {
        Swal.fire("Datos generales incompletos", "Los campos marcados con [ * ] son obligatorios.", "error");
        return false;
    }

    // simacMiembro === 'Si'
    if (simacMiembro === 'Si') {
        if ([
                simacDesde,
                simacTipoMembresia,
            ].includes("")) {
            Swal.fire("Datos incompletos [Datos SIMAC]", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
        }
    }
    // simacMiembro === 'No'
    if (simacMiembro === 'No') {
        if ([
                simacFormarParte,
            ].includes("")) {
            Swal.fire("Datos incompletos [Datos SIMAC]", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
        }
    }

    // tipoRegistro === 'Ponente'
    if (tipoRegistro === 'Ponente') {

        if ([totalTrabajos].includes("")) {
            Swal.fire("Datos incompletos [Tipo de participación]", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
        }

        let isWorkInvalid = null;
        trabajos.forEach( (trab, index) => {

            // Datos de cada trabajo
            if ([
                    trab.trabModalidad,
                    trab.trabTitulo,
                    trab.trabOrientacion,
                    trab.trabResumenTexto,
                    trab.trabPalabrasClave,
                ].includes("")) {
                    isWorkInvalid = index;
            }
            

            // Autores de cada trabajo
            const { trabAutores } = trab;
            console.log({ trabAutores });
            trabAutores.forEach( (autor) => {
                if ([
                        autor.autorApellidos,
                        autor.autorEmail,
                        autor.autorNombres,
                        autor.autorProcedencia,
                    ].includes("")) {
                        isWorkInvalid = index;
                    }
            })

        });

        if (isWorkInvalid !== null) {
            Swal.fire("Datos incompletos", `En [ Tipo de participación ] los campos marcados con * del Trabajo ${isWorkInvalid + 1} son obligatorios.`, "error");
            return false;
        }
    }

    // concursoParticipa === 'Si'
    if (concursoParticipa === 'Si') {
        if ([
                concursoCategoria,
                concursoAsesorApellidoPaterno,
                concursoAsesorNombres,
                concursoAsesorCorreo,
                concursoAsesorInstitucion,
                concursoAsesorTelefono,
                concursoAsesorMiembro,
            ].includes("")) {
            Swal.fire("Datos incompletos [Concurso de tesis]", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
        }
    }

    return true;
};
